<script setup lang="ts">
import { computed, onUnmounted } from "vue";

import Tooltip from "~/components/dumb/Tooltip.vue";
import type { Doc } from "~/shared/types";
import { useDataStore } from "~/stores";
import { makeRelativeTimeForDatesDateRef } from "~/utils/time";
import { getUserDisplayName } from "~/utils/user";

const { doc } = defineProps<{
  doc: Doc;
}>();

const dataStore = useDataStore();

const updatedAtPretty = makeRelativeTimeForDatesDateRef(computed(() => doc.updatedAt));
const createdAtPretty = makeRelativeTimeForDatesDateRef(computed(() => doc.createdAt));
const updatedByMoniker = computed(() => {
  if (!doc.updatedByDuid) {
    return undefined;
  }
  const user = dataStore.getUserByDuid(doc.updatedByDuid);
  if (!user) {
    return undefined;
  }
  return getUserDisplayName(user);
});
const createdByMoniker = computed(() => {
  if (!doc.createdByDuid) {
    return undefined;
  }
  const user = dataStore.getUserByDuid(doc.createdByDuid);
  if (!user) {
    return undefined;
  }
  return getUserDisplayName(user);
});

onUnmounted(() => {
  updatedAtPretty.value.destroy();
  createdAtPretty.value.destroy();
});
</script>

<template>
  <div class="flex select-none flex-col gap-0.5 py-2 pl-3 pr-2 text-xs text-md">
    <p class="flex flex-wrap">
      <span class="text-vlt">Last updated&nbsp;</span>
      <Tooltip :text="updatedAtPretty.full">
        <span>{{ updatedAtPretty.short }}&nbsp;</span>
      </Tooltip>
      <template v-if="updatedByMoniker">
        <span class="text-vlt">by&nbsp;</span>
        <span>{{ updatedByMoniker }}</span>
      </template>
    </p>
    <p class="flex flex-wrap">
      <span class="text-vlt">Created&nbsp;</span>
      <Tooltip :text="createdAtPretty.full">
        <span>{{ createdAtPretty.short }}&nbsp;</span>
      </Tooltip>
      <template v-if="createdByMoniker">
        <span class="text-vlt">by&nbsp;</span>
        <span>{{ createdByMoniker }}</span>
      </template>
    </p>
  </div>
</template>
